import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { AssetAPIService } from 'src/app/extensions/services/api/asset-api.service';
import { RequestAPIService } from 'src/app/extensions/services/api/request-api.service';
import { AddDelegateComponent } from 'src/app/features/my-requests/request-wizard/add-delegate/add-delegate.component';

@Component({
  selector: 'asset-delivery-delegate-modal',
  standalone: false,
  templateUrl: './asset-delivery-delegate-modal.component.html',
  styleUrl: './asset-delivery-delegate-modal.component.scss',
})
export class AssetDeliveryDelegateModalComponent implements OnInit {
  @ViewChild('addForm') addForm!: AddDelegateComponent;

  asset: app.models.AssetListModel;
  addDelegateFormVisible: boolean = false;
  delegates: app.models.Delegate[] = [];
  newDelegate: app.models.Delegate = {} as app.models.Delegate;

  constructor(
    private _activeModal: NgbActiveModal,
    private _requestAPIService: RequestAPIService,
    private _assetAPIService: AssetAPIService,
    private _notificationService: NotificationService,
    private _translateService: TranslateService,
    private _cd: ChangeDetectorRef
  ) {}

  public deliveryDelegateFormGroup = new FormGroup({
    selectedDelegateId: new FormControl(),
  });

  ngOnInit(): void {
    if (this.asset.deliveryDelegateId) {
      this.deliveryDelegateFormGroup.patchValue({
        selectedDelegateId: this.asset.deliveryDelegateId,
      });
      this._cd.detectChanges();
      console.log(this.deliveryDelegateFormGroup.value);
    }

    this._requestAPIService.getDelegates().subscribe(x => {
      this.delegates = x.map(delegate => {
        return {
          ...delegate,
          displayEditIcons: false,
          expiryDate: new Date(delegate.expiryDate),
        };
      });
    });
  }

  addDelegate() {
    this.newDelegate = {} as app.models.Delegate;
    this.addDelegateFormVisible = true;
  }

  saveDelegate() {
    if (this.addForm.addDelegateform.invalid) {
      this.addForm.addDelegateform.form.markAllAsTouched();
      return;
    }

    this.addForm.handlerSaveDelegate();
  }

  delegateSavedHandler(event: app.models.Delegate) {
    if (event.displayEditIcons == true) {
      event.displayEditIcons = false;
      this.addDelegateFormVisible = false;
      this.deliveryDelegateFormGroup.setValue({ selectedDelegateId: event.delegateId });
      return;
    }

    if (event && event.delegateId) {
      this.addDelegateFormVisible = false;
      this.deliveryDelegateFormGroup.setValue({ selectedDelegateId: event.delegateId });
      this.delegates.push(event);
      let indexAddedDelegate = this.delegates.indexOf(event);
      let radioAddedDelegate = document.getElementById('radio-' + indexAddedDelegate);
      if (radioAddedDelegate) {
        radioAddedDelegate.click();
      }
    }
  }

  public editDelegateHandler(selectedDelegate: app.models.Delegate) {
    this.newDelegate = selectedDelegate;
    this.addDelegateFormVisible = true;
  }

  public removeDelegateHandler(selectedDelegate: app.models.Delegate) {
    this.delegates.forEach((element, index) => {
      if (element.delegateId == selectedDelegate.delegateId) {
        this.delegates.splice(index, 1);
      }
    });

    this._requestAPIService.removeDelegate(selectedDelegate.delegateId).subscribe(response => {});
  }

  selectDelegateHandler() {
    if (
      !this.deliveryDelegateFormGroup.value.selectedDelegateId ||
      this.asset.deliveryDelegateId == this.deliveryDelegateFormGroup.value.selectedDelegateId
    ) {
      return;
    }

    this._assetAPIService
      .updateAssetDeliveryDelegate(this.asset.assetDeliveryId, this.deliveryDelegateFormGroup.value.selectedDelegateId!)
      .subscribe(result => {
        if (!result.isSuccess) {
          if (!result.hasValidationErrors) {
            this._notificationService.showError(
              this._translateService.instant('requests.wizard.addDelegateForm.delegateSaveFailed'),
              this._translateService.instant('common.error')
            );
          }

          return;
        }

        this._notificationService.showSuccess(
          this._translateService.instant('requests.wizard.addDelegateForm.delegateSaved'),
          this._translateService.instant('common.success')
        );

        var delegate = this.delegates.find(
          x => x.delegateId == this.deliveryDelegateFormGroup.value.selectedDelegateId
        );

        if (delegate) {
          this.asset.deliveryDelegateId = this.deliveryDelegateFormGroup.value.selectedDelegateId;
          this.asset.deliveryDelegateName = delegate ? delegate.firstName + ' ' + delegate.lastName : '';
        }

        this._activeModal.close(delegate);
      });
  }

  backToDelegatesList() {
    this.addDelegateFormVisible = false;
    this.newDelegate = {} as app.models.Delegate;
  }

  closeModal(): void {
    this._activeModal.close();
  }
}
